export const accountUtilityList = [
    { value: 1, name: "Depósito" },
    { value: 2, name: "Retiro" },
    { value: 3, name: "Ambos" },
  ]